/**
 * Import statements for required dependencies
 */
import { PaginationWithProgress } from '@starsoft/common/components';
import { PaginationWithProgressProps } from '../../PaginationWithProgress/props';
import styles from './styles.module.scss';

/**
 * LoadMore Component
 * A wrapper component that renders a PaginationWithProgress component with styling
 *
 * @param {PaginationWithProgressProps} props - Props passed to PaginationWithProgress component
 * @returns {JSX.Element} A styled div containing PaginationWithProgress
 *
 * @example
 * // Example usage:
 * <LoadMore
 *   currentPage={1}
 *   totalPages={10}
 *   onPageChange={(page) => function(page)}
 *   loading={false}
 * />
 */
export default function LoadMore(props: PaginationWithProgressProps) {
  return (
    <div className={styles.container}>
      <PaginationWithProgress {...props} />
    </div>
  );
}
